module.exports = __webpack_public_path__ + "img/icon_round.835c3b7f.png";